import request from '@/Utils/request.js';
//根据授权得到的code获取用户信息
export function GetWeiXinUserInfo (params) {
    return request({
      url: '/api/WeiXin/GetWeiXinUserInfo',
      method: 'get',
      params: params
    });
}


//生成微信支付订单，并返回支付跳转连接
export function CreateWeiXinPayUrl (params) {
  return request({
    url: '/api/WeiXin/CreateWeiXinPayUrl',
    method: 'post',
    params: params
  });
}

//获取jssdk参数
export function GetJSSDK (params) {
  return request({
    url: '/api/WeiXin/GetJSSDK',
    method: 'get',
    params: params
  });
}